import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  sideNavOpen: boolean;

  constructor() { }

  ngOnInit() {
  }

  openNav(){
    this.sideNavOpen = true;
  }

  closeNav(){
    this.sideNavOpen = false;
  }

}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/header/header.component.ts